const $html = $('html');
const cachedEnvironment = (
  (
    {
      isChina = false,
      availableCustomerBillingTypes,
      isEgonValidation = false,
      language,
      isDebug = false,
      isMobile = false,
      isEgonValidationZipBase = false,
      isVerifaliaValidation = false,
      isLoginPopupEnabled = false,
      isNewsletterPopupEnabled = false,
      isAmazonPayEnabled = false,
      isAmazonPayV2 = false
    }
  ) => {
    return {
      isChina,
      availableCustomerBillingTypes,
      isEgonValidation,
      isEgonValidationZipBase,
      language,
      isDebug,
      isMobile,
      isVerifaliaValidation,
      isLoginPopupEnabled,
      isNewsletterPopupEnabled,
      isAmazonPayEnabled,
      isAmazonPayV2
    }
  }
)({
  isChina: $html.data('is-china-env'),
  availableCustomerBillingTypes: $html.data('available-billing-address'),
  isEgonValidation: $html.data('egon-validation'),
  isEgonValidationZipBase: $html.data('egon-zip-base'),
  language: $html.data('language'),
  isDebug: location.href.match(/debug=42/),
  isMobile: window.matchMedia('(max-width:760px)').matches,
  isVerifaliaValidation: $html.data('verifalia-validation'),
  isLoginPopupEnabled: $html.data('login-popup-enabled'),
  isNewsletterPopupEnabled: $html.data('newsletter-popup-enabled'),
  isAmazonPayEnabled: $html.data('is-amazon-pay-enabled'),
  isAmazonPayV2: $html.data('is-amazon-pay-v2')
})

export const IS_DEBUG = cachedEnvironment.isDebug;
export const IS_CHINA = IS_DEBUG ?
  location.href.match(/isChina/) && location.href.match(/isChina=1/)
  : cachedEnvironment.isChina;
export const AVAILABLE_BILLING_TYPES = cachedEnvironment.availableCustomerBillingTypes;
export const CURRENT_LANG = cachedEnvironment.language;
export const IS_MOBILE = cachedEnvironment.isMobile;
export const IS_EGON_VALIDATION = cachedEnvironment.isEgonValidation;
export const IS_EGON_VALIDATION__ZIP_BASED = cachedEnvironment.isEgonValidationZipBase;
export const IS_VERIFALIA_VALIDATION = cachedEnvironment.isVerifaliaValidation;
export const IS_LOGIN_POPUP_ENABLED = cachedEnvironment.isLoginPopupEnabled;
export const IS_NEWSLETTER_POPUP_ENABLED = cachedEnvironment.isNewsletterPopupEnabled;
export const IS_AMAZON_PAY_ENABLED = cachedEnvironment.isAmazonPayEnabled;
export const IS_AMAZON_PAY_V2 = cachedEnvironment.isAmazonPayV2;
